import { defaultFlareProviderConfiguration } from '../../default-constants';

export const ENOSYS_FLARE_CONTRACT_ADDRESS = '0x088EeCB467B3968Da36c71F05023A1d3133B2B83';

export const ENOSYS_FLARE_PROVIDER_CONFIGURATION = defaultFlareProviderConfiguration;
